export { default } from './ModalAfegirContingut';
